<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
	// Components
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';
	import { conditionsFunc } from 'src/helpers/utilities';

	export let controlOption: LocalControlOptions,
		disabled = false;

	let error = '';

	$: if (!controlOption?.onOffState?.checked || !controlOption.attr.toggle_after) {
		if (!controlOption?.onOffState?.checked) {
			controlOption.attr.toggle_after = false;
		}
		controlOption.params.toggle_after = 0;
		error = '';
	}

	const calculateValue = (_value) => {
		if (conditionsFunc(_value)) {
			error = $format('value_must_be_equal_or_greater_than_zero', {
				default: 'Value must be an integer and equal or greater than 0.',
			});
		} else {
			error = '';
		}
		controlOption.params.toggle_after = _value;
	};
</script>

{#if controlOption?.attr?.toggle_after != undefined}
	<Toggle
		bind:checked={controlOption.attr.toggle_after}
		size="m"
		{disabled}
		info={$format('toggle_title_return_to_previous_state', {
			default: 'Returns the device to its previous state after the set time.',
		})}
		id="toggle-9nquc3x"
	>
		{$format('toggle_value_after', {
			default: 'Toggle value after',
		})}
		{#if controlOption.attr.toggle_after}
			<span class="text-primary">{controlOption.params.toggle_after}</span>
			{$format('select_units_seconds', {
				default: 'seconds',
			})}
		{/if}
	</Toggle>

	{#if controlOption.attr.toggle_after}
		<CustomDynamicInput
			additionalContainerClass="mt-s"
			minusFunction={() => {
				calculateValue(error ? 0 : controlOption.params.toggle_after - 1);
			}}
			disabledMinusBtn={controlOption.params.toggle_after <= 0}
			plusFunction={() => {
				calculateValue(error ? 0 : controlOption.params.toggle_after + 1);
			}}
			value={controlOption.params.toggle_after}
			{error}
			inputHandler={(e) => {
				calculateValue(Number(e.target['value']));
			}}
		/>
	{/if}
{/if}
